var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"143","viewBox":"0 0 48 143"}},[_c('text',{staticClass:"a"},[_c('tspan',{attrs:{"x":"0","y":"116"}},[_vm._v("“\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }